import React from "react";

function Button({
  text,
  icon: Icon,
  outline = false,
  black = false,
  onClick,
  style,
}) {
  return (
    <button
      onClick={onClick ? onClick : null}
      style={style}
      className={`${black ? "border-1 border-black text-black" : ""} ${
        outline
          ? "bg-white text-black border-1 border-black"
          : "text-white border-1 border-white"
      } px-[35px] w-fit py-[12px] font-medium text-sm rounded-[5px] flex items-center justify-center gap-4`}
    >
      {Icon && Icon}
      {text || "Load More"}
    </button>
  );
}

export default Button;
